export default {"en-US": __webpack_public_path__ + "i18n/en-US.d7f0efbd.i18next.json","ja-JP": __webpack_public_path__ + "i18n/ja-JP.23ab64da.i18next.json"};